<template>
  <div>
    <v-tabs
      ref="tabs"
      v-model="tab"
      background-color="var(--color-main-green)"
      class="tender-tabs tabs"
      color="var(--black-color)"
      show-arrows>
      <v-tab
        v-for="(tabItem, tabIndex) in tabs"
        :key="tabIndex"
        class="tab h7-text-medium px-3'"
        :data-qa="`tab-${tabItem.value}`">
        {{ tabItem.name }}
        <div
          v-if="tabItem.count"
          class="tab__badge h9-text-bold black--text'"
          :data-qa="`tab-${tabItem.value}-badge`">
          {{ tabItem.count }}
        </div>
      </v-tab>
      <div class="spacer"/>

      <template v-if="tabs[tab] && tabs[tab].value == 'documents'">
        <ImportDialog
          :apply="addNewFiles"
          :create-file-handler="createFileHandler"
          :files.sync="newFles"
          files-types
          subtitle=" "
          :title="$t('Tenders.AddNewDoc')">
          <template #activator="{ open }">
            <div>
              <TooltipedBtn
                data-qa="btn-add-new-file"
                icon="add-file"
                :text="$t('Tenders.AddNew')"
                :texted="$vuetify.breakpoint.mdAndUp"
                @click="open"/>
            </div>
          </template>
        </ImportDialog>
      </template>
    </v-tabs>
    <v-tabs-items
      id="content-container"
      v-model="tab"
      class="main__green pt-5">
      <v-tab-item data-qa="tab-rows">
        <PurchaseRows
          :application="item"
          :loading="loading"
          :selected.sync="selected"/>
      </v-tab-item>
      <v-tab-item>
        <PurchaseDocuments
          :attachments.sync="attachments"
          :item-id="item.id"/>
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>
<script>
import TooltipedBtn from 'components/common/elements/TooltipedBtn.vue'
import PurchaseRows from 'components/purchasing/purch item/block/PurchaseRows.vue'
import PurchaseDocuments from 'components/purchasing/purch item/block/PurchaseDocuments.vue'
import ImportDialog from 'components/common/dialogs/ImportDialog.vue'

import { mapGetters } from 'vuex'
import { snackbarMixin } from 'mixins'

import ApplicationsApi from '@/api/applicationApi'
const api = new ApplicationsApi()

import { StorageFile } from '@/types/commonFile.js'

export default {
  name: 'PurchaseItemBody',
  mixins: [snackbarMixin],
  data() {
    return {
      tab: 0,
      selected: [],
      attachments: null,
      newFles: [],

      canAgree: false,
    }
  },
  methods: {
    async addNewFiles() {
      this.newFles.forEach((file) => {
        file.uploadFile()
          .then(res => {
            if (res) {
              file.key = res
              file.fileId = res
              file.uri = `${window.config.GrapgQlUrl}/document/${res}`
              this.attachments.unshift(file)
            } else {
              file.error = true
            }
          })
      })
      this.newFles = []
    },
    createFileHandler(file) {
      file.title = file.name
      file.dateModified = new Date()
      return new StorageFile(this.item.id, file, 'Purchasing')
    },
  },
  computed: {
    ...mapGetters({
      userInfo: 'GET_USER'
    }),
    tabs() {
      return [
        {
          name: this.$t('Application.Rows'),
          value: 'rows',
          count: this.item?.items?.length
        },
        {
          name: this.$t('Tenders.Documents'),
          value: 'documents',
          count: this.attachments?.length
        },
      ]
    },
  },
  watch: {
    selected(val) {
      if (val.length > 0) {
        this.$_openSnackbar({
          name: 'item',
          elements: val,
          item: this.item,
          user: this.userInfo,
          canAgree: this.canAgree,
          yourTurn: this.canAgree,
          rejectChoosed: () => { this.selected = [] },
          callback: (quantity, comment, date_type, date) => {
            let item = this.selected[0],
              row = {
                'id': item.id,
                'headerId': +this.item.id,
                'priorityId': date_type || (date ? '' : item.approvedPriority.id) || '',
                'quantity': quantity || item.approvedQuantity,
                'supplyDate': date ? this.$moment(date).format('YYYY-MM-DD') : (date_type || item.approvedPriority.id ? null : this.$moment(item.approvedSupplyDate).format('YYYY-MM-DD')),
                'urgentReason': (date_type == 'U' ? comment : item.approvedPriority.id == 'U' ? item.urgentReason : '') || ''
              }
            api.editApplicationRow(row, comment || '')
              .then(() => {
                const result = {...this.application}
                result.rows[this.application.rows.findIndex(el => el.id == item.id)].urgentReason = row.urgentReason

                this.$emit('update:item', result)
              })
            this.selected = []
          }
        })
      } else if (val.length == 0) {
        this.$_closeSnackbar()
      }
    },
  },
  components: {
    PurchaseRows,
    ImportDialog,
    TooltipedBtn,
    PurchaseDocuments
  },
  props: {
    item: {
      type: Object,
      default: () => ({})
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
}
</script>
